import * as React from "react"
import Svg, { Circle, Path } from "react-native-svg"

function SvgComponent() {
    return (
        <Svg
            width={18}
            height={18}
            viewBox="0 0 18 18"
            fill="none"
        >
            <Circle cx={9} cy={9} r={8.5} stroke="#DBDBDB" />
            <Path
                opacity={0.56}
                d="M12.334 6.5L7.75 11.083 5.667 9"
                stroke="#858585"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </Svg>
    )
}

export default SvgComponent
